export default __webpack_public_path__ + "static/media/rtthread.e90541d2.jpg";